/*
  2026-11-04 (owner: "make all these", reference buy box) — the browser side of the box's dispatch row.
  - Dispatch day in Copenhagen time: Mon–Fri before 16:00 "Sendes i dag", Mon–Thu after 16:00 "Sendes i morgen",
    Fri after 16:00 / Sat / Sun "Sendes mandag" (Cosnetic ships same day before 16). Written into data-now, which
    assets/subrewards.js shows whenever no pre-order length is in the box (a pre-order still wins).
  - [data-cc-flag="DK"] gets the country's flag emoji.
*/
(() => {
  const dayText = (el) => {
    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', weekday: 'short', hour: 'numeric', hour12: false })
        .formatToParts(new Date()).map((p) => [p.type, p.value]));
      const day = parts.weekday, hour = Number(parts.hour) % 24;
      const weekday = !['Sat', 'Sun'].includes(day);
      if (weekday && hour < 16) return el.dataset.today;
      if (weekday && day !== 'Fri') return el.dataset.tomorrow;
      return el.dataset.monday;
    } catch (e) { return null; }
  };
  const run = () => {
    document.querySelectorAll('[data-sr-s-ship][data-today]').forEach((el) => {
      const text = dayText(el);
      if (!text) return;
      el.dataset.now = text;
      if (!el.classList.contains('is-pre') && el.querySelector('[data-sr-s-ship-text]').textContent !== el.dataset.pre) el.querySelector('[data-sr-s-ship-text]').textContent = text;
    });
    document.querySelectorAll('[data-cc-flag]:empty').forEach((el) => {
      const iso = (el.dataset.ccFlag || '').toUpperCase();
      if (/^[A-Z]{2}$/.test(iso)) el.textContent = String.fromCodePoint(...[...iso].map((c) => 127397 + c.charCodeAt(0)));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(run, 60000);
})();
